/**
 * Katalog dostępnych gier.
 *
 * Wspólny dla klienta i serwera, żeby nazwa gry, jej identyfikator i liczba
 * graczy były opisane w jednym miejscu. Klient renderuje z tego ekran wyboru,
 * serwer używa `id` jako `game.game_type` w bazie.
 */
export const GAMES = [
    {
        id: "panstwa-miasta",
        nazwa: "Państwa-Miasta",
        opis: "Losowa litera, kategorie, kto pierwszy krzyknie STOP",
        minGraczy: 2,
        maxGraczy: 12,
    },
    {
        id: "kosci",
        nazwa: "Kości",
        opis: "Pięć kości, trzy rzuty, trzynaście kategorii do zapełnienia",
        minGraczy: 1,
        maxGraczy: 8,
    },
    {
        id: "scrabble",
        nazwa: "Scrabble",
        opis: "Plansza 15×15, 100 płytek, słownik SJP rozstrzyga spory",
        minGraczy: 2,
        maxGraczy: 4,
    },
    {
        id: "catan",
        nazwa: "Osadnicy z Catanu",
        opis: "Trzy do czterech osób, drewno na owce, handel na głos",
        minGraczy: 3,
        maxGraczy: 4,
    },
    {
        id: "superfarmer",
        nazwa: "Superfarmer",
        opis: "Dwie kostki, zwierzęta w parach, lis i wilk czyhają",
        minGraczy: 2,
        maxGraczy: 4,
    },
    {
        id: "perudo",
        nazwa: "Perudo",
        opis: "Kości pod kubkiem, licytacja w ciemno, kto zawoła „kłamiesz”",
        minGraczy: 2,
        maxGraczy: 6,
    },
    {
        id: "literaki",
        nazwa: "Literaki",
        opis: "Dziewięć liter dla wszystkich, dwie minuty, słownik rozstrzyga — po polsku, angielsku albo hiszpańsku",
        minGraczy: 2,
        maxGraczy: 8,
    },
    {
        id: "makao",
        nazwa: "Makao",
        opis: "Karta na kartę, dwójka za dwójkę, król pik bije na pięć",
        minGraczy: 2,
        maxGraczy: 4,
    },
    {
        id: "statki",
        nazwa: "Statki",
        opis: "Flota na planszy 10×10, salwy jednocześnie, trafiony zatopiony",
        minGraczy: 2,
        maxGraczy: 4,
    },
    /*
     * Jeden wpis, nie trzy. Język jest **ustawieniem partii**, a nie osobną grą:
     * trzy wpisy znaczyłyby trzy `game_type` w bazie, trzy komplety kodów faktów
     * i trzy prawie puste czołówki w Rekordach — czyli rozbicie czteroosobowej
     * rodziny na trzy tabele. Ta sama decyzja, co przy kategoriach
     * w Państwach-Miastach.
     */
    {
        id: "wordle",
        nazwa: "Wordle",
        opis: "Jedno hasło, sześć prób, wszyscy naraz — po polsku, angielsku albo hiszpańsku",
        minGraczy: 1,
        maxGraczy: 8,
    },
];
export function gameInfo(id) {
    return GAMES.find((game) => game.id === id) ?? null;
}
/** Nazwa do wyświetlenia; nieznane id nie może wywalić ekranu. */
export function gameName(id) {
    return gameInfo(id)?.nazwa ?? id;
}
//# sourceMappingURL=games.js.map